import { render, staticRenderFns } from "./FinalGradeSelectReviewersCheckboxes.vue?vue&type=template&id=afce028c&scoped=true&"
import script from "./FinalGradeSelectReviewersCheckboxes.vue?vue&type=script&lang=js&"
export * from "./FinalGradeSelectReviewersCheckboxes.vue?vue&type=script&lang=js&"
import style0 from "./FinalGradeSelectReviewersCheckboxes.vue?vue&type=style&index=0&id=afce028c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afce028c",
  null
  
)

export default component.exports